import React, { useState } from "react";

/*

* React FC
  
*/

const Radio = props => {
  const { fieldValue, updateFieldValue } = props;
  const [selected, setSelected] = useState(fieldValue.default);

  const handleSelectChange = e => {
    setSelected(e.target.value);
    updateFieldValue("year")(e);
  };
  return (
    <div
      className="flex-col spacer_sm inputDiv">

      <label for={fieldValue.field} className="para-4 text-black inputLabel">
        {fieldValue.label}
      </label>
      <div className="flex radioBtnContainer">
        {fieldValue.options.map((option, i) => {
          return (
            <>
              <label className="flex-row nowrap space-around align-center radio">
                <input
                  type="radio"
                  value={option.value}
                  checked={selected == option.value}
                  onChange={handleSelectChange}
                />
                <span className="para-3-bold label">{option.label}</span>
                <span className="checkmark" />
              </label>
            </>
          );
        })}
      </div>
      <style jsx>{`
      .radioBtnContainer{
        margin-top:16px;
      }
      .inputDiv{
        padding: 0 8px;
      }
      .inputLabel{
        opacity:0.6;
      }
      .radio{
        margin-right:16px
      }
      .label{
        margin: 0 4px ;
      }
      .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
        background-color: #eee;
        border-radius: 50%;
      }
      .container:hover input ~ .checkmark {
        background-color: #ccc;
      }
      .container input:checked ~ .checkmark {
        background-color: #4dc3b6;
      }
      .checkmark:after {
        content: "";
        position: absolute;
        display: none;
      }
      .container input:checked ~ .checkmark:after {
        display: block;
      }
      .container .checkmark:after {
        top: 9px;
        left: 9px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: white;
      }
      `}</style>
    </div>
  );
};

export default Radio;
